export function objectMap<T, R>(object: { [key: string | number]: T }, fn: (t: T, key: string) => R): { [key: string | number]: R } {
    return Object.keys(object).reduce(function (result: { [key: string | number]: R }, key) {
        result[key] = fn(object[key], key)
        return result
    }, {})
}

export const getCurrentTimeInMillis = () => new Date().getTime();